// @flow
import axios from '../../axios'
import { takeLatest, call, put } from 'redux-saga/effects'
import { createAction, Action } from 'redux-actions'

// Saga action strings
export const SHORTEN_URL = 'saga/ShortUrl/SHORTEN_URL'
export const SHORTEN_URL_SUCCESS = 'saga/ShortUrl/SHORTEN_URL_SUCCESS'
export const SHORTEN_URL_FAILURE = 'saga/ShortUrl/SHORTEN_URL_FAILURE'

export const actions = {
  SHORTEN_URL,
  SHORTEN_URL_SUCCESS,
  SHORTEN_URL_FAILURE
}

type ShortUrlSagaActionCreators = {
  getShortUrl: () => Action<any>,
  getShortUrlSuccess: () => Action<any>,
  getShortUrlFailure: () => Action<any>
}

export const actionCreators: ShortUrlSagaActionCreators = {
  getShortUrl: createAction(SHORTEN_URL),
  getShortUrlSuccess: createAction(SHORTEN_URL_SUCCESS),
  getShortUrlFailure: createAction(SHORTEN_URL_FAILURE)
}

export default function * watchShortUrl () {
  yield takeLatest(SHORTEN_URL, getShortUrl)
}

export function * getShortUrl (action) {
  try {
    const url = window.location.href
    const repoInfo = yield call(axios.post, 'url-shortener', {
      url: url
    })
    yield put(actionCreators.getShortUrlSuccess(repoInfo.data.id))
  } catch (error) {
    yield put(actionCreators.getShortUrlFailure(error))
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/shortUrl/shortUrlSaga.js